import moment from "moment";
import {getQuarterDates} from "./common";

export const defaultCountry = { value: 0, label: 'Беларусь' }
export const defaultCountries = [
  { value: 0, label: 'Беларусь' },
  { value: 1, label: 'Россия' },
  { value: 2, label: 'Украина' }
]
export const optionsPaymentAnnuityDate = Array.from({ length: 25 }, (_, i) => {
  const months = i + 1;
  let label;

  const lastDigit = months % 10;
  const lastTwoDigits = months % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    label = `${months} месяцев`;
  } else if (lastDigit === 1) {
    label = `${months} месяц`;
  } else if (lastDigit >= 2 && lastDigit <= 4) {
    label = `${months} месяца`;
  } else {
    label = `${months} месяцев`;
  }

  return {
    value: months,
    label: label
  };
});

export const dealDurationType = {
  LONG: "LONG",
  SHORT: "SHORT"
}

export const facets = {
  TERM: [
    { value: dealDurationType.LONG, label: 'Долгосрочный' },
    { value: dealDurationType.SHORT, label: 'Краткосрочный'},
  ],
  ENTITY: {
    CARS_FEATURE: [
      { value: 'car', label: 'Автомобиль', active: false },
      { value: 'thing', label: 'Вещи', active: false },
      { value: 'purity', label: 'Д/м', active: false },
    ],
    DEFAULT: [
      { value: 'thing', label: 'Вещи', active: false },
      { value: 'purity', label: 'Д/м', active: false },
    ],
  },
};

export const groups = {
  DEAL: 'typeDeal',
  DURATION: 'typeDuration',
};

export const countries = ['Беларусь', 'Россия', 'Украина']
export const cityTypes = ['г.', 'д.', 'х.', 'гп.', 'п.']
export const streetTypes = ['тр.','вч.', 'ул.', 'пер.', 'пл.', 'туп.', 'б-р', 'пр-д.', 'мкр-н', 'тер.', 'шоссе', 'пр.', 'въезд', 'ст.', 'наб.', 'уроч.', 'пос.', 'вг', 'парк', '-']
export const contactTypes = ['Домашний', 'Мобильный', 'Рабочий']
export const hearAboutTypes = ['Интернет', 'Реклама в печатных изданиях', 'От друзей', 'Реклама на улице', 'Другое']
export const documentTypes = {
  residency: ['Паспорт', 'Вид на жительство', 'Идентификационная карта', 'Биометрический вид на жительство (гражданство иное)', 'Биометрический вид на жительство (без гражданства)', 'Иной документ'],
  another: ['Паспорт', 'Удостоверение беженца', 'Иной документ']
}
export const documentTypesUser = ['Паспорт', 'Вид на жительство', 'Идентификационная карта', 'Иной документ']

export const nonAvailableFunction = 'Функция "Расчет от суммы" недоступна';
export const prolongExpiredDeal = 'Просроченный договор не может быть продлен.';
export const extendBeforeDate = 'Дата договора не соответствует установленным срокам.';
export const paymentErrors = {
  NON_CASH_ERROR: 'Сумма введенных полей должна быть эквивалентна сумме "Взять с клиента"',
  CASH_ERROR: 'Сумма введенных полей превышает максимальное значение',
  AMOUNT_MISMATCH: 'Введённая сумма не совпадает с расчётной',
  PAYMENT_TYPE_REQUIRED: 'Выберите тип оплаты',
  PRICE_MISMATCH: 'Сумма введенных полей должна быть эквивалентна сумме "Цена реализации"',
  PARTIAL_REPAYMENT_ERROR: '"Итого внесено" должно быть больше 0'
};
export const extensionLimitDays = 'Договор продлен на максимально возможное количество дней на текущую дату.';
export const typeDeal = 'Договора должны быть одного типа.';
export const riskMessage = 'Обратите внимание - клиент с высоким итоговым риском!'
export const debtNotificationError = "Микрозаём превышает предельное значение. Рассчитайте ПДН"
export const waitingMessage = 'Подождите, идёт расчёт';
export const inActiveDeal = "Выбранный список содержит неактивные договора"

export const limitDaysForProlong = 30

export const mappedLetters = {
  'В': 'B',
  'М': 'M',
  'С': 'C',
  'Х': 'X',
  'А': 'A',
  'Е': 'E',
  'Т': 'T',
  'У': 'Y',
  'О': 'O',
  'Р': 'P',
  'К': 'K',
  'Н': 'H',
  'в': 'b',
  'м': 'm',
  'с': 'c',
  'х': 'x',
  'а': 'a',
  'е': 'e',
  'т': 't',
  'у': 'y',
  'о': 'o',
  'р': 'p',
  'к': 'k',
  'н': 'h'
}

export const pageOptions = [
  { value: 10, text: '10 строк' },
  { value: 40, text: '40 строк' },
  { value: 60, text: '60 строк' },
  { value: 80, text: '80 строк' },
  { value: 100, text: '100 строк' },
  { value: 120, text: '120 строк' }
]

export const contractStatuses = {
  ACTIVE: { name: 'Активен', style: 'label-success', param: 'ACTIVE' },
  CANCELED: { name: 'Аннулирован', style: 'label-close', param: 'CANCELED' },
  CLOSED: { name: 'Закрыт', style: 'label-close', param: 'CLOSED' },
  EXPIRED: { name: 'Просрочен', style: 'label-success', param: 'EXPIRED' },
  GOHRAN: { name: 'Гохран', style: 'label-close', param: 'GOHRAN' },
  STORE: { name: 'В магазин', style: 'label-gray', param: 'STORE' },
  INVENTORY: { name: 'Инвентарь', style: 'label-gray', param: 'INVENTORY' },
  WITHDRAWAL: { name: 'Изъят', style: 'label-gray', param: 'WITHDRAWAL' },
  TOTRANSFER: { name: 'На передаче', style: 'label-warning', param: 'TOTRANSFER' },
  SALED_STORE: { name: 'Продано', style: 'label-gray', param: 'SALED_STORE' },
  SALED_GOHRAN: { name: 'Архив', style: 'label-gray', param: 'SALED_GOHRAN' },
  GOHRAN_SALE: { name: 'Передано', style: 'label-gray', param: 'GOHRAN_SALE' },
  UNKNOWN: { name: 'Не определен', style: 'label-close', param: 'UNKNOWN' },
  RETENTION: { name: 'Удержание', style: 'label-warning', param: 'RETENTION' },
  UNNECESSARY: { name: 'Отменён', style: 'label-close', param: 'UNNECESSARY' },
  GARAGE: { name: 'Гараж', style: 'label-gray', param: 'GARAGE' },
  GARAGE_ARCHIVE: { name: 'Архив-Гараж', style: 'label-gray', param: 'GARAGE_ARCHIVE' },
  EXPIRED_PAYMENT: { name: 'Активен/просрочен платеж', style: 'label-success', param: 'EXPIRED_PAYMENT' },
}

export const CREATE_OPERATION = 1000; // 18
export const EXPIRED_OPERATION = 1010; // 3
export const EXTENSION_OPERATION = 1011; // 1
export const EXPIRED_RETENTION_OPERATION = 1012;
export const PART_PAYMENT_OPERATION = 1013;
export const ANNUITY_PAYMENT_OVERDUE = 1015;
export const DEPOSITING_MONEY_PAYMENTS = 1014;
export const UNNECESSARY_OPERATION = 1301; // 11

export const EDIT_CASHBOX_NAME_OPERATION = 2001; // 11
export const EDIT_DEAL_NUMBER_OPERATION = 2002; // 12
export const EDIT_DELAY_PERCENT_OPERATION = 2003; // 13
export const EDIT_DEAL_PURITY_POSITIONS_OPERATION = 2004; // 14
export const EDIT_DEAL_THING_POSITIONS_OPERATION = 2005; // 16
export const EDIT_DEAL_THING_ESTIMATED_VALUE_OPERATION = 2006; // 17
export const EDIT_DEAL_PERCENT_OPERATION = 2007; // 22
export const EDIT_DEAL_REDEMPTION_DATE = 2008;
export const EDIT_DEAL_CAR_ESTIMATED_VALUE_OPERATION = 2009;
export const EDIT_DEAL_CAR_POSITIONS_OPERATION = 2010; //

export const STATUS_TRANSFER_OPERATION = 3000; // 19

export const GOHRAN_OPERATION = 4001; // 15
export const STORE_OPERATION = 4002; // 20
export const INVENTORY_OPERATION = 4003; // 25
export const WITHDRAWAL_OPERATION = 4004; // 30
export const ANOTHERSTORE_OPERATION = 4005; // 40
export const GARAGE_OPERATION = 4006; // ??
export const ANOTHERGARAGE_OPERATION = 4007 //
export const REFUND_THINGS = 3098 //

export const GOHRAN_SALE_OPERATION = 5001; // 45
export const STORE_SALE_OPERATION = 5002; // 46
export const GARAGE_ARCHIVE_OPERATION = 5003; // ??

export const BACK_TRANSFER_OPERATION = 3099; // 55

export const CLOSED_OPERATION = 1500; // 2
export const CANCEL_OPERATION = 1300; // 10

export const REVERT_OPERATION = 8000; // 21

export const typeOperations = {
  [ANNUITY_PAYMENT_OVERDUE]: {
    name: 'Просрочен аннуитетный платёж',
    style: 'label-success',
    view: 'AnnuityPayment',
    param: ANNUITY_PAYMENT_OVERDUE
  },
  [DEPOSITING_MONEY_PAYMENTS]: {
    name: 'Внесение денег по платежам',
    style: 'label-success',
    view: 'DepositingMoneyPayments',
    param: DEPOSITING_MONEY_PAYMENTS
  },
  [REFUND_THINGS]: {
    name: 'Возврат невостребованного имущества',
    style: 'label-success',
    view: 'RefundThings',
    param: REFUND_THINGS
  },
  [EXTENSION_OPERATION]: {
    name: 'Продлён',
    style: 'label-success',
    view: 'ExtensionOperation',
    param: EXTENSION_OPERATION
  },
  [CLOSED_OPERATION]: {
    name: 'Закрытие',
    style: 'label-close',
    view: 'CloseOperation',
    param: CLOSED_OPERATION
  },
  [EXPIRED_OPERATION]: {
    name: 'Просрочен',
    style: 'label-close',
    view: 'ExpireOperation',
    param: EXPIRED_OPERATION
  },
  [EXPIRED_RETENTION_OPERATION]: {
    name: 'Возврат с удержания',
    style: 'label-close',
    view: 'ExpiredRetentionOperation',
    param: EXPIRED_RETENTION_OPERATION
  },
  [CANCEL_OPERATION]: {
    name: 'Аннулирован',
    style: 'label-gray',
    view: 'StatusTransferOperation',
    param: CANCEL_OPERATION
  },
  [EDIT_CASHBOX_NAME_OPERATION]: {
    name: 'Правка',
    style: 'label-warning',
    view: 'EditCashBoxNameOperation',
    param: EDIT_CASHBOX_NAME_OPERATION
  },
  [EDIT_DEAL_NUMBER_OPERATION]: {
    name: 'Правка',
    style: 'label-warning',
    view: 'EditDealNumberOperation',
    param: EDIT_DEAL_NUMBER_OPERATION
  },
  [EDIT_DEAL_REDEMPTION_DATE]: {
    name: 'Удержание',
    style: 'label-warning',
    view: 'EditDealRedemptionDate',
    param: EDIT_DEAL_REDEMPTION_DATE
  },
  [EDIT_DELAY_PERCENT_OPERATION]: {
    name: 'Правка',
    style: 'label-warning',
    view: 'EditDelayPercentOperation',
    param: EDIT_DELAY_PERCENT_OPERATION
  },
  [EDIT_DEAL_PURITY_POSITIONS_OPERATION]: {
    name: 'Правка',
    style: 'label-warning',
    view: null,
    param: EDIT_DEAL_PURITY_POSITIONS_OPERATION
  },
  [GOHRAN_OPERATION]: {
    name: 'ГоХран',
    style: 'label-gray',
    view: 'GohranOperation',
    param: GOHRAN_OPERATION
  },
  [EDIT_DEAL_THING_POSITIONS_OPERATION]: {
    name: 'Правка',
    style: 'label-warning',
    view: null,
    param: EDIT_DEAL_THING_POSITIONS_OPERATION
  },
  [EDIT_DEAL_CAR_POSITIONS_OPERATION]: {
    name: 'Правка',
    style: 'label-warning',
    view: null,
    param: EDIT_DEAL_CAR_POSITIONS_OPERATION
  },
  [EDIT_DEAL_THING_ESTIMATED_VALUE_OPERATION]: {
    name: 'Переоценка',
    style: 'label-warning',
    view: 'EditEstimateOperation',
    param: EDIT_DEAL_THING_ESTIMATED_VALUE_OPERATION
  },
  [CREATE_OPERATION]: {
    name: 'Активен',
    style: 'label-success',
    view: 'CreateOperation',
    param: CREATE_OPERATION
  },
  [STORE_OPERATION]: {
    name: 'Магазин',
    style: 'label-gray',
    view: 'StoreOperation',
    param: STORE_OPERATION
  },
  [REVERT_OPERATION]: {
    name: 'Отмена',
    style: 'label-gray',
    view: 'RevertOperation',
    param: REVERT_OPERATION
  },
  [EDIT_DEAL_PERCENT_OPERATION]: {
    name: 'Правка',
    style: 'label-warning',
    view: 'EditDealPercentOperation',
    param: EDIT_DEAL_PERCENT_OPERATION
  },
  [INVENTORY_OPERATION]: {
    name: 'Инвентарь',
    style: 'label-gray',
    view: 'InventoryOperation',
    param: INVENTORY_OPERATION
  },
  [WITHDRAWAL_OPERATION]: {
    name: 'Изъятие',
    style: 'label-close',
    view: 'WithDrawalOperation',
    param: WITHDRAWAL_OPERATION
  },
  [STATUS_TRANSFER_OPERATION]: {
    name: 'Возвращён в обработку',
    style: 'label-warning',
    view: 'StatusTransferOperation',
    param: STATUS_TRANSFER_OPERATION
  },
  [GOHRAN_SALE_OPERATION]: {
    name: 'Продано',
    style: 'label-gray',
    view: 'GohranSaleOperation',
    param: GOHRAN_SALE_OPERATION
  },
  [STORE_SALE_OPERATION]: {
    name: 'Продано',
    style: 'label-gray',
    view: 'StoreSaleOperation',
    param: STORE_SALE_OPERATION
  },
  [ANOTHERSTORE_OPERATION]: {
    name: 'В магазин',
    style: 'label-gray',
    view: 'AnotherStoreOperation',
    param: ANOTHERSTORE_OPERATION
  },
  [BACK_TRANSFER_OPERATION]: {
    name: 'Возврат на передачу',
    style: 'label-warning',
    view: 'BackTransferOperation',
    param: BACK_TRANSFER_OPERATION
  },
  [UNNECESSARY_OPERATION]: {
    name: 'Отменён',
    style: 'label-close',
    view: 'UnnecessaryOperation',
    param: UNNECESSARY_OPERATION
  },
  [GARAGE_OPERATION]: {
    name: 'Гараж',
    style: 'label-gray',
    view: 'GarageOperation',
    param: GARAGE_OPERATION
  },
  [ANOTHERGARAGE_OPERATION]: {
    name: 'Перевод в другой ломбард',
    style: 'label-gray',
    view: 'AnotherGarageOperation',
    param: ANOTHERGARAGE_OPERATION
  },
  [GARAGE_ARCHIVE_OPERATION]: {
    name: 'Архив-Гараж',
    style: 'label-gray',
    view: 'GarageSaleOperation',
    param: GARAGE_ARCHIVE_OPERATION
  },
  [EDIT_DEAL_CAR_ESTIMATED_VALUE_OPERATION]: {
    name: 'Переоценка',
    style: 'label-warning',
    view: 'EditEstimateOperation',
    param: EDIT_DEAL_CAR_ESTIMATED_VALUE_OPERATION
  },
  [PART_PAYMENT_OPERATION]: {
    name: 'Частичное гашение',
    style: 'label-part',
    view: 'PartPaymentOperation',
    param: PART_PAYMENT_OPERATION
  },
}

export const DEBIT_TYPE = 0;
export const CREDIT_TYPE = 1;

export const sectionsVisem = {
  "CLOSURE_AMOUNT": {
    name: "Погашено микрозаймов",
    code: 1005,
    type: CREDIT_TYPE,
    prompt: 'Реестр погашенных микрозаймов №',
    isDisabled: false
  },
  "CLOSURE_USAGE": {
    name: "Проценты за пользование микрозаймом",
    code: 1004,
    type: CREDIT_TYPE,
    prompt: 'Реестр погашенных микрозаймов №, Реестр продлений № ',
    isDisabled: false
  },
  "BASE_EXPIRE": {
    name: "Проценты по договорам микрозаймов",
    code: 1001,
    type: CREDIT_TYPE,
    prompt: 'Реестр погашенных микрозаймов №, Реестр продлений № ',
    isDisabled: false
  },
  "DELAY_EXPIRE": {
    name: "Неустойка по договорам микрозаймов",
    code: 1002,
    type: CREDIT_TYPE,
    prompt: 'Реестр погашенных микрозаймов №',
    isDisabled: false
  },
  "EXTEND_EXPIRE": {
    name: "Продление микрозаймов",
    code: 1003,
    type: CREDIT_TYPE,
    prompt: 'Реестр продления №',
    isDisabled: false
  },
  "SALE": {
    name: "Реализация невостребованного товара",
    code: 1007,
    type: CREDIT_TYPE,
    prompt: 'Реестр реализованного имущества №',
    isDisabled: false
  },
  "TICKET_LOST": {
    name: "Выдача дубликата утерянного залогового билета",
    code: 1006,
    type: CREDIT_TYPE,
    prompt: 'Реестр погашенных микрозаймов №',
    isDisabled: true
  },
  "ISSUE_DEAL": {
    name: "Выдача микрозаймов",
    code: 1,
    type: DEBIT_TYPE,
    prompt: 'Реестр выданных микрозаймов №',
    isDisabled: false
  },
  "CLOSURE_RECALCULATION": {
    name: "Перерасчёт по микрозаймам",
    code: 1008,
    type: DEBIT_TYPE,
    prompt: 'Ведомость перерасчёта №',
    isDisabled: false
  },
  "NON_CASH_ERIP": {
    name: "Безнал. расчет за ломбардные операции ЕРИП",
    code: 1012,
    type: DEBIT_TYPE,
    prompt: '',
    isDisabled: false
  },
  "NON_CASH": {
    name: "Безнал. расчет за ломбардные операции",
    code: 1011,
    type: DEBIT_TYPE,
    prompt: '',
    isDisabled: false
  },
}

export const paymentTypeVisem = [
  {value: 'Наличные операции', label: 'Наличные операции'},
  {value: 'ЕРИП', label: 'ЕРИП'},
  {value: 'Безналичные операции', label: 'Безналичные операции'},
  {value: 'Все операции', label: 'Все операции'},
]
export const paymentType = [
  {value: 'CASH', label: 'Наличные операции'},
  {value: 'NON_CASH', label: 'Безналичные операции касса'},
  {value: 'NON_CASH_ACCOUNT', label: 'Безналичные операции р/счет'},
  {value: 'BANK_TRANSACTION', label: 'ЕРИП'},
  {value: null, label: 'Все операции'},
]

export const reportType = [
  {value: 'CASH', label: 'Наличные операции'},
  {value: 'NON_CASH', label: 'Безналичные операции'},
  {value: 'ALL', label: 'Все операции'},
]

export const typeSms = [
  {value: 'STANDARD', label: 'СМС в свободной форме', active: false, action: 'typeSms'},
  {value: 'AFTER_EXPIRED', label: 'СМС после выхода на просрочку', active: false, action: 'typeSms'},
  {value: 'NOT_ACTIVE', label: 'СМС для неактивных клиентов', active: false, action: 'typeSms'},
  {value: 'BEFORE_EXPIRED', label: 'СМС перед выходом на просрочку', active: false, action: 'typeSms'},
]

export const statusSms = [
  {value: 'QUEUED', label: 'Ожидание отправки', active: false, action: 'statusSms'},
  {value: 'BAD_PHONE', label: 'Ошибка номера телефона', active: false, action: 'statusSms'},
  {value: 'DELIVERED', label: 'Доставлено', active: false, action: 'statusSms'},
  {value: 'SENT', label: 'Отправлено', active: false, action: 'statusSms'},
  {value: 'BAD_FORMAT_TEXT', label: 'Ошибка валидации текста смс', active: false, action: 'statusSms'},
  {value: 'FAILED', label: 'Ошибка', active: false, action: 'statusSms'},
]

export const sections = {
  "CLOSURE_AMOUNT": {
    name: "Погашено микрозаймов",
    code: 1005,
    type: CREDIT_TYPE,
    prompt: 'Ведомость погашенных микрозаймов №',
    isDisabled: false
  },
  "ISSUE_DEAL_SECTION_MORE_12_MONTHS_DEAL": {
    name: "Выдача микрозаймов сроком более 12 месяцев",
    code: 1014,
    type: DEBIT_TYPE,
    prompt: 'Ведомость выданных микрозаймов №',
    isDisabled: false
  },
  "CLOSURE_AMOUNT_SECTION_MORE_12_MONTHS_DEAL": {
    name: "Погашено займов сроком более 12 месяцев",
    code: 1016,
    type: CREDIT_TYPE,
    prompt: 'Ведомость погашенных микрозаймов №',
    isDisabled: false
  },
  "CLOSURE_USAGE": {
    name: "Проценты за пользование микрозаймом",
    code: 1004,
    type: CREDIT_TYPE,
    prompt: 'Ведомость погашенных микрозаймов №',
    isDisabled: false
  },
  "BASE_EXPIRE": {
    name: "Проценты за период льготного срока",
    code: 1001,
    type: CREDIT_TYPE,
    prompt: 'Ведомость начисленных процентов за период льготного срока №',
    isDisabled: false
  },
  "DELAY_EXPIRE": {
    name: "Погашено пени по микрозаймам",
    code: 1002,
    type: CREDIT_TYPE,
    prompt: 'Ведомость начисленных процентов за период льготного срока №',
    isDisabled: false
  },
  "EXTEND_EXPIRE": {
    name: "Продление микрозаймов",
    code: 1003,
    type: CREDIT_TYPE,
    prompt: 'Ведомость продления №',
    isDisabled: false
  },
  "SALE": {
    name: "Реализация невостребованного товара",
    code: 1007,
    type: CREDIT_TYPE,
    prompt: 'Ведомость реализованного невостребованного имущества №',
    isDisabled: false
  },
  "TICKET_LOST": {
    name: "Выдача дубликата утерянного залогового билета",
    code: 1006,
    type: CREDIT_TYPE,
    prompt: 'Реестр погашенных микрозаймов №',
    isDisabled: true
  },
  "ISSUE_DEAL": {
    name: "Выдача микрозаймов",
    code: 1,
    type: DEBIT_TYPE,
    prompt: 'Ведомость выданных микрозаймов №',
    isDisabled: false
  },
  "CLOSURE_RECALCULATION": {
    name: "Перерасчёт по микрозаймам",
    code: 1008,
    type: DEBIT_TYPE,
    prompt: 'Ведомость перерасчёта №',
    isDisabled: false
  },
  "NON_CASH": {
    name: "Безнал. расчет за ломбардные операции касса",
    code: 1011,
    type: DEBIT_TYPE,
    prompt: '',
    isDisabled: false,
    isDefaultPayment: true
  },
  "NON_CASH_ACCOUNT": {
    name: "Безнал. расчет за ломбардные операции на р/с",
    code: 1013,
    type: DEBIT_TYPE,
    prompt: '',
    isDisabled: false,
    isDefaultPayment: true
  },
  "NON_CASH_ERIP": {
    name: "Безнал. расчет за ломбардные операции ЕРИП",
    code: 1012,
    type: DEBIT_TYPE,
    prompt: '',
    isDisabled: false,
    isDefaultPayment: true
  },
}

export const automaticOperationReasons = {
  'REFUND': {
    value: 1010,
    label: 'Возврат невостребованного имущества',
  },
  'RECULCULATION': {
    value: 1008,
    label: 'Перерасчёт',
  }
}

export const basisForCloseAndProlongDeal = {
  'NEW_BASE_EXPIRE': 'Проценты за пользование микрозаймом ',
  'PENALTY': 'Начисленная неустойка ',
  'VISEM': {
    'BASE_EXPIRE': 'Проценты по договору микрозайма ',
    'DELAY_EXPIRE': 'Неустойка по договору микрозайма ',
    'NEW_DELAY_EXPIRE': 'Проценты по договору микрозайма ',
  },
  'CREDITON': {
    'BASE_EXPIRE': 'Проценты за период льготного срока ' ,
    'DELAY_EXPIRE': 'Погашено пени по микрозайму '
  }
}

export const viewDocument = {
  isWithdrawal: 'isWithdrawal',
  isInventory: 'isInventory',
  isTN: 'isTN',
  isRegister: 'isRegister',
  isOverestimation: 'isOverestimation',
  isToTransfer: 'isToTransfer',
  isKBWithdrawal: 'isKBWithdrawal',
  isTransferdSaledGoHran: 'isTransferdSaledGoHran',
  isTransferdSaledStore: 'isTransferdSaledStore',
  isToStore: 'isToStore',
  isProlong: 'isProlong',
  isClosed: 'isClosed',
  isCloseAnnuityDeal: 'isCloseAnnuityDeal',
  isCopy: 'isCopy',
  isAnnul: 'isAnnul',
  isEdit: 'isEdit',
  isTransferAnotherStore: 'isTransferAnotherStore',
  isToGarage: 'isToGarage',
  isToTransferArchiveGarage: 'isToTransferArchiveGarage',
  isPayAnnuity: 'isPayAnnuity'
}

export const typeDataGrossIncome = [
  {label: 'Драг. металлы', value: 'PURITY'},
  {label: 'Вещи', value: 'THINGS'},
  {label: 'Авто', value: 'CARS'},
]

export const typeGrossIncome = [
  {label: 'Начисленный', value: 'expected'},
  {label: 'Фактический', value: 'actual'},
]

export const todayStart = moment().startOf('day').valueOf()
export const todayEnd = moment().endOf('day').valueOf()
export const timeOptions = [
  {
    displayName: 'За все время',
    key: 'all',
    start: moment('2022-01-01'),
    end: todayEnd
  },
  {
    displayName: 'Сегодня',
    key: 'today',
    start: todayStart,
    end: todayEnd
  },
  {
    displayName: 'Вчера',
    key: 'yesterday',
    start: moment(todayStart).subtract(1, 'days').valueOf(),
    end: moment(todayEnd).subtract(1, 'days').valueOf()
  },
  {
    displayName: 'Неделя',
    key: 'week',
    start: moment().startOf('week').subtract(1, 'week').valueOf(),
    end: moment().startOf('week').valueOf() - 1
  },
  {
    displayName: 'Текущий месяц',
    key: 'month',
    start: moment().startOf('month').valueOf(),
    end: moment().endOf('month').valueOf()
  },
  {
    displayName: 'Предыдущий месяц',
    key: 'prev_month',
    start: moment().startOf('month').subtract(1, 'months').valueOf(),
    end: moment().startOf('month').subtract('months').valueOf() - 1
  }
]

const currentDate = moment();
const currentYear = currentDate.year();
export const timeOptionsGrossIncome = [
  {
    displayName: 'За все время',
    key: 'all',
    start: moment('2022-01-01'),
    end: todayEnd
  },
  {
    displayName: 'Квартал 1',
    key: 'quarter1',
    start: getQuarterDates(1).startDate,
    end: getQuarterDates(1).endDate
  },
  {
    displayName: 'Квартал 2',
    key: 'quarter2',
    start: getQuarterDates(2).startDate,
    end: getQuarterDates(2).endDate
  },
  {
    displayName: 'Квартал 3',
    key: 'quarter3',
    start: getQuarterDates(3).startDate,
    end: getQuarterDates(3).endDate
  },
  {
    displayName: 'Квартал 4',
    key: 'quarter4',
    start: getQuarterDates(4).startDate,
    end: getQuarterDates(4).endDate
  },
  {
    displayName: 'Год',
    key: 'year',
    start: moment({ year: currentYear, month: 0, day: 1 }).format('YYYY-MM-DD'),
    end: moment({ year: currentYear, month: 11, day: 31 }).format('YYYY-MM-DD')
  }
]

export const viewReports = {
  INTERNAL_MOVEMENT_STORE: 'INTERNAL_MOVEMENT_STORE',
  INTERNAL_MOVEMENT_GOHRAN: 'INTERNAL_MOVEMENT_GOHRAN',
  PRINTED_DEAL: 'PRINTED_DEAL',
  MARKDOWN_ACT: 'MARKDOWN_ACT',
  SUPPLEMENTARY_AGREEMENT: 'SUPPLEMENTARY_AGREEMENT',
  MOVEMENT_GOHRAN: 'MOVEMENT_GOHRAN',
  MOVEMENT_GOHRAN_JSON: 'MOVEMENT_GOHRAN_JSON',
  INVENTORY_FROM_STORE: 'INVENTORY_FROM_STORE',
  SUPPLEMENTARY_AGREEMENT_PERCENT: 'SUPPLEMENTARY_AGREEMENT_PERCENT',
  INVENTORY_INVOICE: 'INVENTORY_INVOICE',
  SALE_INVOICE: 'SALE_INVOICE',
  WITHDRAWAL: 'WITHDRAWAL',
  NBRB_MONTH: 'NBRB_MONTH',
  NBRB_QUARTER: 'NBRB_QUARTER',
  MOVEMENT_STORE: 'MOVEMENT_STORE',
  CAR_INSPECTION: 'CAR_INSPECTION',
  CLOSE_DEAL_RECEIPT: 'CLOSE_DEAL_RECEIPT',
  ADDITIONAL_AGREEMENT: 'ADDITIONAL_AGREEMENT',
  MOVEMENT_GARAGE: 'MOVEMENT_GARAGE',
  GROSS_INCOME: 'GROSS_INCOME',
  GOHRAN_REPORT: 'GOHRAN_REPORT',
  CASH_BALANCES: 'CASH_BALANCES',
  INTERNAL_MOVEMENT_GOHRAN_PL: 'INTERNAL_MOVEMENT_GOHRAN_PL',
  CLIENTS_COUNT: 'CLIENTS_COUNT',
  CLIENTS_REPORT: 'CLIENTS_REPORT',
  OPERATIONS_REPORT: 'OPERATIONS_REPORT',
  REVALUATION_ACT: 'REVALUATION_ACT',
  DEBT_OVERLOAD_ACT: 'DEBT_OVERLOAD_ACT',
  DEBT_REPORT: 'DEBT_REPORT',
  CREDIT_REPORT_CALCULATION: 'CREDIT_REPORT_CALCULATION'
}

export const listRoles = {
  ACCOUNTANT: "ACCOUNTANT",
  GOODS_SPECIALIST: "GOODS_SPECIALIST",
  MARKETER: "MARKETER",
  ADMIN: "ADMIN",
  DIRECTOR: "DIRECTOR",
  BRANCH_DIRECTOR: "BRANCH_DIRECTOR",
  LOYAL_GOODS_SPECIALIST: "LOYAL_GOODS_SPECIALIST"
}


export const kbTypes = {
  CREATE: 'Создание договора',
  REMAINING_DEBT: 'Задолженность',
  EDIT_CLIENT: 'Редактирование анкеты клиента',
  CREATE_CLIENT: 'Создание анкеты клиента',
  CANCELLATION: 'Отмена договора',
  CLOSE: 'Закрытие договора',
  SALE: 'Продажа договора',
  GOHRAN: 'Передача в архив',
  WITHDRAWAL: 'Изъятие',
  INVENTORY: 'Передача в инвентарь',
  EXTENSION: 'Продление',
  CANCEL_CLOSE: 'Отмена закрытия',
  CANCEL_EXTENSION: 'Отмена продление',
  CHANGE_NUMBER: 'Изменения номера договора',
  THIRD_PARTY_CLOSE: 'Закрытие третьим лицом',
  THIRD_PARTY_CLOSE_ANNUITY: 'Закрытие третьим лицом',
  REPORT: 'Запрос кредитной истории',
  UNKNOWN: 'Неопределенная операция',
  CANCEL_SALE: 'Отмена продажи',
  CANCEL_PAYMENT: 'Отмена платежа',
  OVERDUE: 'Просрочен платёж',
  CLOSE_ANNUITY: 'Закрытие договора',
  PAYMENT: 'Платёж',
}

export const kbStatus = {
  'IN_PROGRESS': {
    label: 'label-warning',
    text: 'Ожидание'
  },
  'SUCCESS': {
    label: 'label-success',
    text: 'Успешно'
  },
  'ERROR': {
    label: 'label-close',
    text: 'Ошибка'
  },
  'REPEAT': {
    label: 'label-gray',
    text: 'Повтор'
  },
  'UNKNOWN': {
    label: 'label-gray',
    text: 'Статус не определён'
  }
}

export const smsTypes = {
  NOT_ACTIVE: 'СМС для неактивных клиентов',
  BEFORE_EXPIRED: 'СМС перед выходом на просрочку',
  AFTER_EXPIRED: 'СМС после выхода на просрочку',
  STANDARD: 'СМС в свободной форме',
  UNKNOWN: 'Тип смс не определён'
}

export const smsStatus = {
  'QUEUED': {
    label: 'label-warning',
    text: 'Ожидание отправки'
  },
  'SENT': {
    label: 'label-success',
    text: 'Отправлено'
  },
  'DELIVERED': {
    label: 'label-success',
    text: 'Доставлено'
  },
  'FAILED': {
    label: 'label-close',
    text: 'Ошибка'
  },
  'BAD_PHONE': {
    label: 'label-close',
    text: 'Ошибка номера телефона'
  },
  'BAD_FORMAT_TEXT': {
    label: 'label-close',
    text: 'Ошибка валидации текста смс'
  },
  'UNKNOWN': {
    label: 'label-gray',
    text: 'Статус не определён'
  }
}

export const clientsReportStateOptions = [
  { value: "newClients", label: "Новый клиент" },
  { value: "regularClients", label: "Постоянные клиенты" },
  { value: "allClients", label: "Все" },
];

export const SEARCH_RESULTS = 'SEARCH_RESULTS'
export const COMBINE_PROFILES = 'COMBINE_PROFILES'
export const REPORTS_NBRB = 'REPORTS_NBRB'
export const CANCEL_OPERATION_BUTTON = 'CANCEL_OPERATION_BUTTON'
export const TNSTORE_TRANSFER_OPERATIONS = 'TNSTORE_TRANSFER_OPERATIONS'
export const LIMITED_SEARCH_RESULTS = 'LIMITED_SEARCH_RESULTS'
export const TRANSFER_TO_RETENTION = 'TRANSFER_TO_RETENTION'
export const TRANSFER_DEALS = 'TRANSFER_DEALS'
export const SEND_SMS = 'SEND_SMS'
export const FORM_AN_INVENTORY = 'FORM_AN_INVENTORY'
export const RETURN_TO_TRANSFER = 'RETURN_TO_TRANSFER'
export const RETURN_TO_TRANSFER_IN_SOLD = 'RETURN_TO_TRANSFER_IN_SOLD'
export const DOWNLOAD_FILE_PRA = 'DOWNLOAD_FILE_PRA'
export const DATA_TRANSFER_TO_AIS_KB = 'DATA_TRANSFER_TO_AIS_KB'
export const PRINT = 'PRINT'
export const SEND_FOR_SALE = 'SEND_FOR_SALE'
export const GARAGE_OPERATIONS = 'GARAGE_OPERATIONS'
export const EDIT_TRANSACTION = 'EDIT_TRANSACTION'
export const CANCEL_TRANSACTION = 'CANCEL_TRANSACTION'
export const REPORTS = 'REPORTS'
export const REPORTS_OTHER = 'REPORTS_OTHER'
export const GROSS_INCOME = 'GROSS_INCOME'

export const accesses = {
  [SEARCH_RESULTS]: [
    listRoles.ADMIN,
    listRoles.DIRECTOR,
    listRoles.MARKETER,
    listRoles.BRANCH_DIRECTOR,
  ],
  [LIMITED_SEARCH_RESULTS]: [
    listRoles.ADMIN,
    listRoles.DIRECTOR,
    listRoles.BRANCH_DIRECTOR,
    listRoles.MARKETER,
    listRoles.ACCOUNTANT,
  ],
  [COMBINE_PROFILES]: [listRoles.ADMIN],
  [REPORTS_NBRB]: [
    listRoles.ADMIN,
    listRoles.DIRECTOR,
    listRoles.MARKETER,
    listRoles.ACCOUNTANT
  ],
  [CANCEL_OPERATION_BUTTON]: [listRoles.ADMIN],
  [TNSTORE_TRANSFER_OPERATIONS]: [
    listRoles.ADMIN,
    listRoles.DIRECTOR,
    listRoles.GOODS_SPECIALIST
  ],
  [TRANSFER_TO_RETENTION]: [
    listRoles.ADMIN,
    listRoles.DIRECTOR,
    listRoles.GOODS_SPECIALIST
  ],
  [TRANSFER_DEALS]: [
    listRoles.ADMIN,
    listRoles.DIRECTOR,
    listRoles.GOODS_SPECIALIST
  ],
  [RETURN_TO_TRANSFER]:[
      listRoles.ADMIN,
      listRoles.DIRECTOR
  ],
  [RETURN_TO_TRANSFER_IN_SOLD]:[
    listRoles.ADMIN,
    listRoles.DIRECTOR,
    listRoles.GOODS_SPECIALIST
  ],
  [FORM_AN_INVENTORY]:[
    listRoles.ADMIN,
    listRoles.DIRECTOR
  ],
  [DOWNLOAD_FILE_PRA]: [
      listRoles.ADMIN,
      listRoles.DIRECTOR,
      listRoles.ACCOUNTANT
  ],
  [DATA_TRANSFER_TO_AIS_KB]: [
      listRoles.ADMIN
  ],
  [PRINT]: [
      listRoles.ADMIN,
      listRoles.DIRECTOR,
      listRoles.MARKETER,
      listRoles.ACCOUNTANT,
      listRoles.GOODS_SPECIALIST
  ],
  [SEND_FOR_SALE]: [
      listRoles.ADMIN,
      listRoles.DIRECTOR,
      listRoles.GOODS_SPECIALIST
  ],
  [GARAGE_OPERATIONS]: [
      listRoles.ADMIN,
      listRoles.DIRECTOR,
      listRoles.GOODS_SPECIALIST
  ],
  [EDIT_TRANSACTION]: [
      listRoles.ADMIN,
      listRoles.DIRECTOR,
      listRoles.ACCOUNTANT
  ],
  [CANCEL_TRANSACTION]: [
      listRoles.ADMIN,
      listRoles.DIRECTOR,
      listRoles.ACCOUNTANT,
      listRoles.GOODS_SPECIALIST
  ],
  [REPORTS]: [
      listRoles.ADMIN,
      listRoles.DIRECTOR,
      listRoles.MARKETER,
      listRoles.ACCOUNTANT,
      listRoles.GOODS_SPECIALIST,
      listRoles.BRANCH_DIRECTOR
  ],
  [REPORTS_OTHER]: [
      listRoles.ADMIN,
      listRoles.DIRECTOR,
      listRoles.MARKETER,
      listRoles.ACCOUNTANT,
      listRoles.BRANCH_DIRECTOR
  ],
  [SEND_SMS]: [
    listRoles.ADMIN,
    listRoles.DIRECTOR,
    listRoles.GOODS_SPECIALIST,
  ],
  [GROSS_INCOME]: [
    listRoles.BRANCH_DIRECTOR,
    listRoles.ADMIN,
    listRoles.DIRECTOR,
    listRoles.MARKETER,
  ]
}


export const timePeriods = {
  months: {
    0: { title: 'Январь', type: 'xlsx' },
    1: { title: 'Февраль', type: 'xlsx' },
    2: { title: 'Март', type: 'xlsx' },
    3: { title: 'Апрель', type: 'xlsx' },
    4: { title: 'Май', type: 'xlsx' },
    5: { title: 'Июнь', type: 'xlsx' },
    6: { title: 'Июль', type: 'xlsx' },
    7: { title: 'Август', type: 'xlsx' },
    8: { title: 'Сентябрь', type: 'xlsx' },
    9: { title: 'Октябрь', type: 'xlsx' },
    10: { title: 'Ноябрь', type: 'xlsx' },
    11: { title: 'Декабрь', type: 'xlsx' },
  },
  quarter: {
    1: { title: 'I - квартал', type: 'xlsx' },
    2: { title: 'II - квартал', type: 'xlsx' },
    3: { title: 'III - квартал',type: 'xlsx' },
    4: { title: 'IV - квартал', type: 'xlsx' },
  },
};

export const defaultCategories = [
  {value: 0, label: "Без категории"},
  {value: 1, label: "Бонус"},
  {value: 2, label: "Надёжный"},
  {value: 3, label: "VIP"},
  {value: 4, label: "Праздничный"},
  {value: 5, label: "Золотой"},
  {value: 6, label: "Серебряный"},
  {value: 7, label: "Ночной"},
  {value: 8, label: "Льготный"},
  {value: 9, label: "Социальный"},
  {value: 10, label: "VIP (Отказ от выкупа)"}
]

export const maxLength = {
  ADDITIONAL: 2000,
  SERVICE_INFORMATION: 3000,
  SERVICE_INFORMATION_RISK: 500,
  SPECIAL_FORM: 30,
  CODE_SUSPICION: 3
};

export const prolongDate = {
  visem: {
    NEW_PROLONG_DATE: "2025-02-05",
    OLD_DEAL_PROLONG_DATE: "2024-10-01",
    ZERO_DELAY_DATE: "2024-09-30",
  },
  crediton: {
    NEW_PROLONG_DATE: "2025-04-03",
    OLD_DEAL_PROLONG_DATE: "2024-11-23",
    ZERO_DELAY_DATE: "2024-11-22"
  },
}

export const wordForms = {
  dayForm: { singular: 'день', few: 'дня', plural: 'дней' },
  resultForms: { singular: 'результат', few: 'результата', plural: 'результатов' }
}

export const permissions = {
  1: "action.client.list",
  2: "action.cashbox.list",
  3: "action.deal.list",
  4: "action.elastic.index",
  5: "action.elastic.search",
  6: "action.deal.index",
  7: "action.client.create",
  8: "action.employee.create",
  9: "action.employee.update.password",
  10: "action.employee.list",
  11: "action.report.generate",
  12: "action.client.update",
  13: "action.client.deactivate",
  14: "action.client.activate",
  15: "action.client.details",
  16: "action.client.short",
  17: "action.employee.update.roles",
  18: "action.employee.details",
  19: "action.employee.edit",
  20: "action.cashbox.details",
  21: "action.cashbox.create",
  22: "action.cashbox.update",
  23: "action.employee.typeahead",
  24: "action.purities.details",
  25: "action.purities.update",
  26: "action.words.details",
  27: "action.words.update",
  33: "action.cashbox.available",
  34: "action.address.reload",
  35: "action.address.list",
  36: "action.deal.create",
  37: "action.deal.extension",
  38: "action.deal.status.cancellation",
  39: "action.deal.closure",
  40: "action.transaction.list",
  41: "action.deal.update",
  42: "action.deal.operations.list",
  44: "action.deal.status.transfer",
  45: "action.deal.edit",
  46: "action.deal.update.thing.estimated.value",
  47: "action.deal.transfer",
  48: "action.transaction.create",
  49: "action.reason.update",
  50: "action.reason.listing",
  51: "action.deal.sale.store",
  52: "action.deal.sale.gohran",
  53: "action.transfer.listing",
  54: "action.cashbox.delete",
  55: "action.transaction.batch.create",
  56: "action.transaction.revert",
  57: "action.operation.revert",
  58: "action.branch.calculate",
  59: "action.branch.dealInfo",
  60: "action.cashbox.coupons",
  61: "action.cashbox.typeahead",
  62: "action.cashbox.shortList",
  63: "action.purities.current",
  64: "action.words.purities",
  65: "action.deal.closure.calculation",
  66: "action.deal.extension.calculate",
  67: "action.transaction.list.groups",
  68: "action.employee.details.current",
  69: "action.elastic.load.file",
  70: "action.client.union",
  71: "action.deal.redemption.date",
  72: "action.integration.kb.event",
  73: "action.integration.kb.list",
  74: "action.integration.kb.details",
  75: "action.integration.kb.mark",
  76: "action.transaction.update",
  77: "action.deal.sale.garage",
  78: "action.auto.create",
  79: "action.auto.update",
  80: "action.deal.sms.list",
  81: "action.sms.bulk",
  82: "action.sms.send",
  83: "action.sms.status",
  84: "action.sms.balance",
  85: "action.sms.list",
  86: "action.cashbox.get_typeahead_response.for_all",
  87: "action.cashbox.get_typeahead_response.for_goods_specialists",
  88: "action.cashbox.process_available_cashboxes.find_all_by_activeis",
  89: "action.cashbox.process_available_cashboxes.find_distinct_all_by_userid",
  90: "action.cashbox.get_cashbox_details_response",
  91: "client.validate_document_info_dates",
  92: "client.process_list",
  93: "deal.get_closure_date",
  94: "deal.get_last_operation",
  95: "deal.cancel_deal",
  96: "deal.process_deal_number",
  97: "deal.validate_sale_store",
  98: "deal.check_all_deals_and_user_from_one_cashbox",
  99: "deal.validate_by_user_roles.all",
  100: "deal.validate_by_user_roles.admin",
  101: "deal.transaction_update",
  102: "deal.get_redemption_deal",
  103: "deal.get_redemption_deal.director",
  104: "action.system.manage.permission",
  105: "action.report.cash_balances.generate",
  106: "action.branch.create",
  107: "action.branch.delete",
  108: "action.branch.list",
  109: "action.branch.update",
  110: "action.advert.add",
  111: "action.advert.delete",
  112: "action.advert.details",
  113: "action.cashbox.details_by_director_id",
  114: "action.report.generate.gross_income",
  115: "action.user.create.role",
  116: "action.overdue.load.file",
  117: "action.overdue.load.aiskb",
  118:  "elastic.facets.client.total",
  119:  "elastic.facets.client.count",
  120:  "elastic.facets.client.creation_date",
  121:  "elastic.facets.client.branch",
  122:  "elastic.facets.client.cashbox",
  123:  "elastic.facets.deal.branch",
  124:  "elastic.facets.deal.car_brand",
  125:  "elastic.facets.deal.car_date",
  126:  "elastic.facets.deal.cashbox",
  127:  "elastic.facets.deal.creation_date",
  128:  "elastic.facets.deal.type",
  129:  "elastic.facets.deal.end_date",
  130:  "elastic.facets.deal.purity_name",
  131:  "elastic.facets.deal.purity_type",
  132:  "elastic.facets.deal.status",
  133: "report.generate.client_profile",
  134: "deal.update.cashbox_name",
  135: "deal.update.deal_number",
  136: "deal.update.delay_percent",
  137: "deal.update.base_percent",
  138: "deal.create.copy",
  139: "action.elastic.load.file",
  140: "report.generate.data_export",
  141: "expired.branch_director.search",
  142: "report.generate.gohran",
  143: "action.deal.transfer.gohran",
  144: "action.deal.transfer.withdrawal",
  145: "action.deal.status.transfer.active",
  146: "action.deal.status.transfer.totransfer",
  147: "action.report.generate.archive",
  148: "action.deal.transfer.anotherstore",
  149: "action.deal.transfer.inventory",
  150: "action.report.generate.gohran",
  151: "action.report.generate.store",
  152: "action.deal.status.transfer.store",
  153: "action.deal.status.transfer.expired",
  154: "reports.registers",
  155: "reports.global",
  156: "reports.inventory",
  157: "reports.others",
  158: "calculations.quick",
  159: "calculations.quick.save",
};

const ClientCountKeys = {
  YEAR: "Год",
  QUARTER: "Квартал",
  COUNT: "Количество",
};

export const clientCountValues = ({ year, quarter, profilesCount }) => ({
  [ClientCountKeys.YEAR]: year,
  [ClientCountKeys.QUARTER]: quarter && `${quarter} квартал`,
  [ClientCountKeys.COUNT]: profilesCount,
});

export const paymentGroups = {
  CASH: "cash",
  NON_CASH: "nonCash",
  NON_CASH_ACCOUNT: "nonCashAccount",
  BANK_TRANSACTION: "bankTransaction",
  ERIP: "erip",
};

export const paymentLabels = {
  [paymentGroups.CASH]: "НАЛИЧНЫЕ",
  [paymentGroups.NON_CASH]: "БЕЗНАЛ КАССА",
  [paymentGroups.NON_CASH_ACCOUNT]: "БЕЗНАЛ Р/С",
  [paymentGroups.BANK_TRANSACTION]: "ЕРИП",
};

export const paymentOptions = [
  { value: paymentGroups.CASH, group: paymentGroups.CASH, label: paymentLabels[paymentGroups.CASH] },
  {
    label: "Безналичные",
    group: paymentGroups.NON_CASH,
    options: [
      { value: paymentGroups.NON_CASH, label: paymentLabels[paymentGroups.NON_CASH] },
      { value: paymentGroups.NON_CASH_ACCOUNT, label: paymentLabels[paymentGroups.NON_CASH_ACCOUNT], isSaleGoods: true },
    ],
  },
  { value: paymentGroups.BANK_TRANSACTION, group: paymentGroups.ERIP, label: paymentLabels[paymentGroups.BANK_TRANSACTION] },
];

export const paymentOperationOptions = [
  { label: 'Наличный', value: 'CASH' },
  { label: 'Безналичный', value: 'NON_CASH' }
];

export const creditDealTypeCode = {
  MFO_LOAN_AGREEMENT: 16,
  MFO_PLEDGE_AGREEMENT: 17,
  MFO_AGREEMENT_DEPOSIT_THINGS: 27,
}

export const StatusPaymentAnnuityPeriod = {
  closed: 'CLOSED',
  active: 'ACTIVE',
  expired: 'EXPIRED',
  future: 'FUTURE'
}

export const couponType = {
  SHORT_TERM: 'SHORT_TERM',
  ANNUITY: 'ANNUITY',
  ANNUITY_HYBRID: 'ANNUITY_HYBRID'
}

export const generateCouponTypes = (showHybrid) => {
  const baseTypes = [
    couponAnnuityType.SHORT_TERM,
    couponAnnuityType.ANNUITY
  ];

  if (showHybrid) {
    return [...baseTypes, couponAnnuityType.ANNUITY_HYBRID];
  }

  return baseTypes;
};

export const couponAnnuityType = {
  SHORT_TERM: 'Краткосрочный',
  ANNUITY: 'Аннуитет',
  ANNUITY_HYBRID: 'Гибридный аннуитет',
}

export const dealTypes = {
  SHORT_TERM: {
    couponType: 'SHORT_TERM',
    dealForm: 'SHORT_TERM',
    label: 'Расчет',
  },
  ANNUITY_CLASSIC: {
    couponType: 'ANNUITY',
    dealForm: 'ANNUITY_CLASSIC',
    label: 'Аннуитет',
  },
  ANNUITY_DELAYED_START: {
    couponType: 'ANNUITY',
    dealForm: 'ANNUITY_DELAYED_START',
    label: 'Аннуитет авто',
  },
  ANNUITY_HYBRID: {
    couponType: 'ANNUITY_HYBRID',
    dealForm: 'ANNUITY_HYBRID',
    label: 'Гибридный аннуитет',
  }
};

export const generateDealFormTabs = (showAnnuityAuto, showHybrid) => [
  dealTypes.SHORT_TERM,
  showAnnuityAuto ? dealTypes.ANNUITY_DELAYED_START : dealTypes.ANNUITY_CLASSIC,
    ...(showHybrid && !showAnnuityAuto ? [dealTypes.ANNUITY_HYBRID] : [])
];

export const ERROR_MESSAGES = {
  INVALID_CONTRACTS: 'Выбранный список содержит неподходящие договоры',
};

